import apiClient from '@/lib/api/apiClient'
import { extractErrorMessage } from '@/lib/utils/errorHandling'
import type {
  ReportDescription,
  ReportDescriptionListParams,
  ReportDescriptionSubmitPayload,
} from '../types'

const BASE_ENDPOINT = '/api/report_description'

function asReportDescriptionList(data: unknown): ReportDescription[] {
  if (Array.isArray(data)) return data
  if (data && typeof data === 'object') {
    const nested = (data as { data?: unknown }).data
    if (Array.isArray(nested)) return nested
  }
  return []
}

/** Build query string params — Angular sends every key present on `urlParams`, values raw. */
function toQueryParams(
  params: ReportDescriptionListParams,
): Record<string, string> {
  const query: Record<string, string> = {}
  if (params.orderBy) query.orderBy = params.orderBy
  if (params.sortBy) query.sortBy = params.sortBy
  if (params.q !== undefined) query.q = params.q
  if (params.page != null) query.page = String(params.page)
  return query
}

export async function getReportDescriptions(
  params: ReportDescriptionListParams = {},
): Promise<ReportDescription[]> {
  try {
    const response = await apiClient.get<unknown>(BASE_ENDPOINT, {
      params: toQueryParams(params),
    })
    return asReportDescriptionList(response.data)
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to load report descriptions')
  }
}

export async function saveReportDescription(
  payload: ReportDescriptionSubmitPayload,
  originalReportName?: string,
): Promise<ReportDescription> {
  try {
    const url = originalReportName
      ? `${BASE_ENDPOINT}/${encodeURIComponent(originalReportName)}`
      : BASE_ENDPOINT
    const response = await apiClient.post<ReportDescription>(url, payload)
    return response.data
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to save report description')
  }
}
